import React from 'react';
import { IUserSummary } from '../../../types/global/helper';
import { Box, Container, Stack, Typography } from '@mui/material';
import { ThspianAvatar } from '../../Avatar/ThspianAvatar';
import { useThemeContext } from '../../../hook/useThemeManager';
import { FONT_ENUM } from '../../../types/global/fonts.types';
import { theme } from '../../../constants/theme';
import { ISubmission } from '../../../redux/jury/types';
import { isEmpty } from '../../../utils/lodash';
import { GenericModal } from '../../GenericModal/GenericModal';
import { createFullName } from '../../../utils/AppUtils';

interface IJudgeMessage {
    submissions: ISubmission;
    open: boolean;
    onClose: () => void;
}
export const JudgeMessage: React.FC<IJudgeMessage> = ({ submissions, open, onClose }) => {
    const { themeStyle, device } = useThemeContext();
    const { other_jury_scores, jury, judge_note } = submissions || {};
    const singleMessageRender = (user: IUserSummary, message: string, key: any) => {
        return (
            <Stack direction="row" alignItems="center" gap="10px" key={key}>
                <ThspianAvatar user={user} enableDefaultNavigation />
                <Box
                    sx={{
                        backgroundColor: theme[themeStyle].deep_grey,
                        width: '100%',
                        alignItems: 'flex-start',
                        justifyContent: 'center',
                        borderRadius: 2,
                        p: 3,
                    }}>
                    <Typography
                        sx={{
                            fontFamily: FONT_ENUM.MAIN_MEDIUM,
                            color: theme[themeStyle].tag_white,
                            fontSize: 14,
                        }}>
                        "{message}"
                    </Typography>
                    {!!user && (
                        <Typography
                            sx={{
                                fontFamily: FONT_ENUM.MAIN_MEDIUM,
                                color: theme[themeStyle].form_label,
                                fontSize: 12,
                            }}>
                            {createFullName(user as any)}
                        </Typography>
                    )}
                </Box>
            </Stack>
        );
    };
    return (
        <GenericModal
            open={open}
            handleClose={onClose}
            childrenStyle={{
                padding: 0,
            }}
            paperStyle={{
                minHeight: device.isMobile ? '100vh' : '50vh',
                width: device.isMobile ? '100vw' : '50vw',
                padding: 2,
            }}>
            <Container style={{ padding: '10px' }}>
                {jury && judge_note && singleMessageRender(jury as unknown as IUserSummary, judge_note, 1)}
                {!!other_jury_scores &&
                    !isEmpty(other_jury_scores) &&
                    other_jury_scores.map((ju, index) => {
                        /** Hack to fetch judge details TODO: Fix */
                        const currentJuror = { ...ju };
                        return (
                            !!jury &&
                            ju.judge_note &&
                            singleMessageRender(currentJuror.jury as unknown as IUserSummary, ju.judge_note, index)
                        );
                    })}
            </Container>
        </GenericModal>
    );
};
